import type { ResolverInput, ResolverResult } from './types';

// §1.1: unstubbed. Reads has_intro_offers from the parent-fetched
// get_setup_progress snapshot. True when any service for this business
// has intro_enabled = true.
export async function resolveIntroOffersItem(
  { progress }: ResolverInput,
): Promise<ResolverResult> {
  if (progress.has_intro_offers) return { complete: true, reason: 'intro offers configured' };
  return { complete: false, reason: 'no intro offers' };
}
